import { useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import MessageError from "../../messages/messageError";

import api from "../../services/api";
import { useSelector } from "react-redux";
import MessageSuccess from "../../messages/messageSuccess";
import FazerObservacoes from "../components/fazerObservacoes.";
import ButtonLeft from "../../utils/buttonLeft";

export default function ChangeStatusAdmin({ admin, setHandleUpdate }) {
  const [messageSuccess, setMessageSuccess] = useState("");
  const [messageError, setErrorMessage] = useState("");
  const [status, setStatus] = useState(admin?.status);
  const [load, setLoad] = useState(false);
  const user = useSelector((state) => state.account.user);
  const [obs, setObs] = useState("");
  // console.log(admin)

  async function changeStatusAdmin() {
    setLoad(true);
    setErrorMessage("");
    setMessageSuccess("");

    await api
      .patch("/admin/change-status", {
        status,
        adminId: admin._id,
        userId: user._id,
        descricao: obs,
      })
      .then((response) => {
        // console.log(response)
        setLoad(false);
        setMessageSuccess(response?.data.msg);
        setHandleUpdate(response.data);
      })
      .catch((error) => {
        // console.log(error)
        setErrorMessage(error.response?.data.message);
        setLoad(false);
      });
  }

  return (
    <>
      {messageSuccess && <MessageSuccess message={messageSuccess} />}
      {messageError && <MessageError message={messageError} />}

      <div style={{ margin: 10 }}>
        <TextField
          type="text"
          label="Estado do funcionário"
          select
          fullWidth
          size="small"
          variant="outlined"
          onChange={(e) => setStatus(e.target.value)}
          defaultValue={admin?.status}
        >
          <MenuItem key={"a"} value={"Activo"} name="status">
            Activo
          </MenuItem>
          <MenuItem key={"i"} value={"Inactivo"} name="status">
            Inactivo
          </MenuItem>
        </TextField>

        {status !== admin?.status && (
          <>
            <FazerObservacoes
              observacao={obs}
              setObs={setObs}
              obs={obs}
              titulo="(Descreve aqui os motivos)"
            />
            <ButtonLeft funcao={changeStatusAdmin} title={'Salvar'} load={load} disabled={load || !status} />
          </>
        )}
      </div>
    </>
  );
}
